import { ButtonFrame, CardSearch, ExportData, PageBodyHeader, Table } from "../../component";
import { useEffect, useState } from "react";
import { generalObj } from "../../constant/object_types";
import { useOutletContext, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { fetchDamageProductChild, fetchProductDmgListChildReport, fetchProductDmgListReturnReport } from "../../action/generalFunc";
import { toast } from "react-toastify";

const ProductDamagedSublevel = () => {
    const [productList, setProductList] = useState<generalObj[]>([]);
    const [productReturnList, setProductReturnList] = useState<generalObj[]>([]);
    const [productInfo, setProductInfo] = useState<string>("");
    const [searchText, setSearchText] = useState<string>("");
    const [searchTextRet, setSearchTextRet] = useState<string>("");
    const [storeName, setStoreName] = useState<string>("");
    const [vendorName, setVendorName] = useState<string>("");

    const {setModalLoading}:{setModalLoading:Function} = useOutletContext();
    const account = useSelector((state:RootState) => state.account);
    const { product_id } = useParams();

    useEffect(() => {
        if (!account || !account.isAuthenticated || !product_id) return;
        (async () => {
            setModalLoading(true);
            
            (async () => {
                let dmg_result = await fetchDamageProductChild(account.token, undefined, undefined, product_id);
                
                if (!dmg_result) {
                    window.history.back();
                }else {
                    let store_name = dmg_result.products_damage[0].store;
                    let vendor_name = dmg_result.products_damage[0].vendor;
                    setProductList(dmg_result.products_damage);
                    setProductReturnList(dmg_result.products_return);
                    setProductInfo(`${dmg_result.product_info.name} ${dmg_result.product_info.size}`);
                    setStoreName(`${store_name.name} - ${store_name.organization}`);
                    setVendorName(`${vendor_name}`);
                    setModalLoading(false)
                }
                
            })();
        })();
    }, [account, product_id, setModalLoading]);


    
    const processExport = (export_type:string) => {
        generateReport(export_type)
    }

    const processExportsec = (export_type:string) => {
        generateReportReturn(export_type)
    }

    const onSearch = (val:string, damaged?:boolean) => {
        if (damaged) {
            setProductList((prevProductList) => {
                return (
                    prevProductList.filter((item) => {
                        if (item.comment.toLowerCase().includes(val.toLowerCase()) || val.toLowerCase().includes(item.damage) || val.toLowerCase().includes(item.returns) || val.toLowerCase().includes(item.return_date)) {
                            item.show = true;
                        }else {
                            item.show = false;
                        }
                        return item;
                    })
                )
            })
            setSearchText(val);
        }else {
            setProductReturnList((prevProductReturnList) => {
                return (
                    prevProductReturnList.filter((item) => {
                        if (item.return_qty.toString().toLowerCase().includes(val) || item.return_date.toString().toLowerCase().includes(val)) {
                            item.show = true;
                        }else {
                            item.show = false;
                        }
                        return item;
                    })
                )
            })
            setSearchTextRet(val);
        }
    }

    const generateReport = async (exportType:string) => {
        if (!exportType || !account || !account.isAuthenticated || !product_id) return;

        setModalLoading(true);
        let param = {
            type: exportType,
            product_id: product_id
        };
        
        let result = await fetchProductDmgListChildReport(account.token, param);

        if (result && typeof(result) === "object") {
            const aElement = document.createElement('a');
            aElement.setAttribute('download', `product_damage_admin.${result.data.type.split("/")[1]}`);
            const href = URL.createObjectURL(result.data);
            aElement.href = href;
            aElement.setAttribute('target', '_blank');
            aElement.click();
            URL.revokeObjectURL(href);
            toast("Report generated");
        }
        setModalLoading(false);
    }

    const generateReportReturn = async (exportType:string) => {
        if (!exportType || !account || !account.isAuthenticated || !product_id) return;

        setModalLoading(true);
        let param = {
            type: exportType,
            product_id: product_id
        };
        
        let result = await fetchProductDmgListReturnReport(account.token, param);

        if (result && typeof(result) === "object") {
            const aElement = document.createElement('a');
            aElement.setAttribute('download', `product_return_admin.${result.data.type.split("/")[1]}`);
            const href = URL.createObjectURL(result.data);
            aElement.href = href;
            aElement.setAttribute('target', '_blank');
            aElement.click();
            URL.revokeObjectURL(href);
            toast("Report generated");
        }
        setModalLoading(false);
    }

    return (
        <>
            <PageBodyHeader title="Damages and Returns" desc="List of Damaged and Returned Products" />

            <div>
                <Table table_head={["ID", "Quantity Damaged",  "Comments"]} th_class="white" color={"#1159AB"} thColor={"#1159AB"} 
                tableSearch={<CardSearch value={searchText} onTextChange={(evt) => onSearch(evt, true)} />}
                tableAction={
                    <div style={{display:"flex", gap:"20px", alignItems:'center'}}>
                        <ExportData export_type={(val) => processExport(val)} />
                        <ButtonFrame btn_text="Back" btn_style={{padding:"8px 24px", borderRadius:"8px", border:"1px solid #808280",  backgroundColor:"#808280", color:"#FFF", fontSize:"14px", fontWeight:"600", letterSpacing:"-0.4px"}} onPress={() => window.history.back()} />
                    </div>
                }
                headerStyle={{marginBottom: "44px"}}
                table_title={`${productInfo} Damages for ${vendorName.toUpperCase()} in ${storeName}`}
                >
                    <>
                        {productList.map((item, index) => (
                            (item.show || item.show === undefined) && (
                                <tr key={index}>
                                    <td>#{item.id}</td>
                                    <td>{item.damage}</td>
                                    <td>{item.comment}</td>
                                </tr>
                            )
                        ))}
                    </>
                </Table>
            </div>

            <div style={{marginTop:"32px"}}>
                <Table table_head={["ID", "Return Quantity",  "Return Date"]} th_class="white" color={"#1159AB"} thColor={"#1159AB"} 
                tableSearch={<CardSearch value={searchTextRet} onTextChange={(evt) => onSearch(evt, false)} />}
                tableAction={
                    <div style={{display:"flex", gap:"20px", alignItems:'center'}}>
                        <ExportData export_type={(val) => processExportsec(val)} />
                    </div>
                }
                headerStyle={{marginBottom: "44px"}}
                table_title={`${productInfo} Returns for ${vendorName.toUpperCase()} in ${storeName}`}
                >
                    <>
                        {productReturnList.map((item, index) => (
                            (item.show || item.show === undefined) && (
                                <tr key={index}>
                                    <td>#{item.id}</td>
                                    <td>{item.return_qty}</td>
                                    <td>{item.return_date}</td>
                                </tr>
                            )
                        ))}
                    </>
                </Table>
            </div>
        </>
    )
}

export default ProductDamagedSublevel;